import { render } from "./TotalNonCurrentLiabilities.vue?vue&type=template&id=765925db&scoped=true"
import script from "./TotalNonCurrentLiabilities.vue?vue&type=script&lang=js"
export * from "./TotalNonCurrentLiabilities.vue?vue&type=script&lang=js"

import "./TotalNonCurrentLiabilities.vue?vue&type=style&index=0&id=765925db&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-765925db"]])

export default __exports__